import { render, staticRenderFns } from "./Dailycustomer.vue?vue&type=template&id=3c793d01&scoped=true&"
import script from "./Dailycustomer.vue?vue&type=script&lang=js&"
export * from "./Dailycustomer.vue?vue&type=script&lang=js&"
import style0 from "./Dailycustomer.vue?vue&type=style&index=0&id=3c793d01&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c793d01",
  null
  
)

export default component.exports